import { googleLogout } from "@react-oauth/google";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import CandidateSupportModal from "../../../components/CandidateSupportModal/CandidateSupportModal";
import Icon from "../../../components/Icon";
import { useAuth } from "../../../context/Auth/AuthContext";
import { getSettingssRoutes } from "../../../handlers/navigationItems";

function EmployerDashboardSidebar({ navItems, screenWidth, screenHeight, showSideBar, setShowSideBar }) {
	const location = useLocation();
	const { logout } = useAuth();
	const [openNeedHelpModal, setOpenNeedHelpModal] = useState(false);
	const toggleNeedHelp = () => {
		setOpenNeedHelpModal(!openNeedHelpModal);
	};

	return (
		<>
			{openNeedHelpModal && <CandidateSupportModal show={openNeedHelpModal} close={toggleNeedHelp} />}
			{(screenWidth > 768 || showSideBar) && (
				<div
					className={`${screenWidth <= 768 ? "absolute top-0 right-0 left-0 bottom-0 bg-black bg-opacity-40 z-[999]" : ""}`}
					onClick={() => {
						setShowSideBar(false);
					}}
				>
					<div
						className="flex flex-col justify-between items-start py-8 w-[230px] bg-[#f7f8f8]"
						style={{
							height: screenWidth > 768 ? `calc(${screenHeight}px - 24px)` : `${screenHeight}px`,
						}}
						onClick={(event) => {
							event.stopPropagation();
							setShowSideBar(true);
						}}
					>
						<div className="flex flex-col items-start w-full">
							{getSettingssRoutes().some((item) => item?.route === location.pathname) ? (
								<Link to="/my-resumes">
									<div className="flex items-center cursor-pointer">
										<i className="bi bi-chevron-left mr-3" />
										<span className="text-lg font-semibold text-gray-500">Settings</span>
									</div>
								</Link>
							) : (
								<Link to="/" className="ml-3">
									<img src="/images/logo.png" alt="Logo" className="max-w-[90px] mb-2" />
								</Link>
							)}

							{navItems &&
								navItems.map((item, index) => {
									if (item.type === "group") {
										return (
											<div key={index} className="font-medium pl-3 pt-4 text-sm">
												{item.name}
											</div>
										);
									}

									return (
										<Link
											key={index}
											to={item.route}
											onClick={() => {
												item.onClick && item.onClick();
												screenWidth <= 768 && setShowSideBar(false);
											}}
										>
											<div
												className={`flex items-center px-3 py-1.5 rounded-lg w-[230px] ${
													location.pathname === item.route ? "bg-blue-50 text-blue-600 rounded-lg" : "text-gray-700"
												}`}
											>
												{item?.icon && <Icon iconName={item?.icon} size={item?.iconSize} />}
												<div className={`text-sm ml-2 ${location.pathname === item.route ? "text-blue-600" : ""}`}>
													{item.name}
												</div>
											</div>
										</Link>
									);
								})}
						</div>
						<div className="flex flex-col items-center text-center mx-auto">
							<div className="font-normal text-sm text-[#b5bac4]">Need help?</div>
							<div className="font-normal text-sm text-[#b5bac4]">
								Contact our{" "}
								<span
									className="cursor-pointer font-medium"
									style={{ color: "#34A3FC", fontWeight: 500 }}
									onClick={() => toggleNeedHelp()}
								>
									support team
								</span>
							</div>
							<button
								onClick={() => {
									googleLogout();
									logout();
									window.location.href = "/signin";
								}}
							>
								<div className="flex items-center text-blue-500 pt-3">
									<i className="bi bi-box-arrow-right pr-3" />
									Logout
								</div>
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export default EmployerDashboardSidebar;
